var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useMergeRefs } from "../../../../common/useFallbackRef";
import { addIconSVG } from "../../../technical-fundamental/Icon/Icon/Icon.utils";
import { Dropdown, DropdownButton, DropdownContent } from "../../../core";
var HeaderToolsUserDropdown = forwardRef(function (_a, ref) {
    var id = _a.id, _b = _a.label, label = _b === void 0 ? "Mon espace" : _b, icon = _a.icon, iconSvg = _a.iconSvg, noBorder = _a.noBorder, className = _a.className, style = _a.style, children = _a.children, otherProps = __rest(_a, ["id", "label", "icon", "iconSvg", "noBorder", "className", "style", "children"]);
    var _c = useState(false), isMobile = _c[0], setIsMobile = _c[1];
    var _d = useState(false), alignRight = _d[0], setAlignRight = _d[1];
    var refItem = useRef(null);
    var combinedRefItem = useMergeRefs([ref, refItem]);
    var handleResize = function () {
        setIsMobile(window.innerWidth < 992);
    };
    useEffect(function () {
        handleResize();
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    useEffect(function () {
        if (isMobile) {
            setAlignRight(false);
            return;
        }
        if (refItem.current) {
            var collapseElement = refItem.current.querySelector(".fr-collapse.ssg-header-tools-user-menu__dropdown-content");
            var parentElement = refItem.current.parentElement;
            if (collapseElement && parentElement) {
                var right = parentElement.getBoundingClientRect().right;
                var width = collapseElement.getBoundingClientRect().width;
                var left = refItem.current.getBoundingClientRect().left;
                if (left + width > right) {
                    setAlignRight(true);
                    return;
                }
            }
        }
        setAlignRight(false);
    }, [children, isMobile]);
    var userDropdownClass = "ssg-header-tools-user-menu";
    if (alignRight) {
        userDropdownClass += " ssg-header-tools-user-menu--align-right";
    }
    if (noBorder) {
        userDropdownClass += " ssg-header-tools-user-menu--no-border";
    }
    if (className) {
        userDropdownClass += " ".concat(className);
    }
    var btnClass = "ssg-header-tools-user-menu__dropdown-btn fr-btn";
    if (icon) {
        btnClass += " " + icon;
    }
    if (icon || iconSvg) {
        btnClass += " fr-btn--icon-left";
    }
    var _e = addIconSVG(iconSvg, btnClass, {}), buttonClassName = _e.className, buttonStyle = _e.style;
    return (React.createElement("div", __assign({}, otherProps, { className: userDropdownClass, ref: combinedRefItem, style: style }),
        React.createElement(Dropdown, { id: id },
            React.createElement(DropdownButton, { className: buttonClassName, style: buttonStyle }, label),
            React.createElement(DropdownContent, { className: "ssg-header-tools-user-menu__dropdown-content fr-menu" },
                React.createElement("div", { className: "ssg-header-tools-user-menu__content" }, children)))));
});
export default HeaderToolsUserDropdown;
